const STORAGE_KEY = 'mercately_voice_tab_session_id';

/**
 * @returns {string}
 */
function createVoiceTabSessionId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `tab_${Date.now()}_${Math.random().toString(36).slice(2)}`;
}

/**
 * Stable id per browser tab (sessionStorage). Different tabs get different SIP legs.
 * @returns {string}
 */
export default function getOrCreateVoiceTabSessionId() {
  try {
    const existing = sessionStorage.getItem(STORAGE_KEY);
    if (existing && existing.trim()) {
      return existing.trim();
    }
    const created = createVoiceTabSessionId();
    sessionStorage.setItem(STORAGE_KEY, created);
    return created;
  } catch {
    return createVoiceTabSessionId();
  }
}

/**
 * Abandon the current tab SIP identity after a broken REGISTER/WSS cycle so FreeSWITCH
 * does not accumulate zombie contacts on `agent_<oldTabId>`.
 * @returns {string} new tab session id
 */
export function rotateVoiceTabSessionId() {
  const created = createVoiceTabSessionId();
  try {
    sessionStorage.setItem(STORAGE_KEY, created);
  } catch {
    // sessionStorage may be unavailable; callers still use the in-memory value via return
  }
  return created;
}

/**
 * @returns {void}
 */
export function clearVoiceTabSessionId() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
